export const APP_REDUCER = 'app';
export const I18N_REDUCER = 'i18n';
export const AUTH_REDUCER = 'auth';
export const USER_REDUCER = 'user';
export const PAGE_REDUCER = 'page';
export const LOTTO_REDUCER = 'lotto';
export const FORMS_REDUCER = 'forms';
export const POPUPS_REDUCER = 'popups';
export const DEVICE_REDUCER = 'device';
export const SOCKET_REDUCER = 'socket';
export const JACKPOTS_REDUCER = 'jackpots';
export const PAYMENTS_REDUCER = 'payments';
export const LIVE_GAMES_REDUCER = 'liveGames';
export const SPORTSBOOK_REDUCER = 'sportsbook';
export const GAME_LAUNCH_REDUCER = 'gameLaunch';
export const LOYALTY_POINTS_REDUCER = 'loyaltyPoints';
export const COOKIE_SETTINGS_REDUCER = 'cookieSettings';
export const TERMS_CONDITIONS_REDUCER = 'termsConditions';
export const CASINO_COMPONENT_REDUCER = 'casinoComponent';
export const MY_ACCOUNT_SIDEBAR_REDUCER = 'myAccountSidebar';
export const GAMES_CONFIGURATION_REDUCER = 'gamesConfiguration';
export const COMMUNICATION_WIDGETS_REDUCER = 'communicationWidgets';
export const PROMOTIONS_CONFIGURATION_REDUCER = 'promotionsConfiguration';
